/** @format */

import React from 'react';

import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function DataDetails() {
  const navigate = useNavigate();
  function handleFileStat() {
    navigate('/settings/file-stat');
  }
  return (
    <Paper variant="outlined" sx={{ flex: '0 1 300px', height: '300px' }}>
      <Box
        sx={{
          width: '100%',
          textAlign: 'left',
          p: 1,
        }}
      >
        <Typography variant="subtitle1">Data Details</Typography>
      </Box>
      <Divider flexItem />
      <Box sx={{ p: 1 }}>
        <Button
          onClick={handleFileStat}
          color="secondary"
          size="small"
          variant="text"
        >
          File Stats
        </Button>
      </Box>
    </Paper>
  );
}

export default DataDetails;
